<template>
  <div class="partner-portal">
    <div class="common-title">{{$t("partner.title")}}</div>
    <div class="nkn-container">
      <partner-topology-graph></partner-topology-graph>
    </div>
    <div class="nkn-container">
      <partner-more></partner-more>
    </div>
    <div class="nkn-container">
      <partners-module></partners-module>
    </div>
    <div class="nkn-container">
      <about-partner></about-partner>
    </div>
  </div>
</template>

<script>
import PartnerTopologyGraph from '@/components/partner/TopologyGraph'
import PartnersModule from '@/components/partner/nknPartners'
import PartnerMore from '@/components/partner/nknMore'
import AboutPartner from '@/components/about/nknPartner'
import {mapGetters} from 'vuex'
export default {
  components: {
    PartnerTopologyGraph, PartnersModule, PartnerMore, AboutPartner
  },
  computed: {
    ...mapGetters({
      lang: 'getLang'
    })
  },
  metaInfo() {
    if (this.$i18n.locale === 'zh') {
      return {
        title: '合作伙伴门户',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        attribute: '',
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: '生态系统，合作伙伴产业链和介绍。'
          }
        ]
      }
    } else {
      return {
        title: 'Partner Portal | The New Kind of Network',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: 'We\'re collaborating with multiple partners, vendors and platforms to bring you the world\'s largest decentralized blockchain network. Click here to see the list '
          }
        ]
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.partner-portal{
  width: 100%;
  .common-title {
    padding: 80px 0;
    padding-bottom: 0;
    @media screen and (max-width: 768px) {
      padding: 40px 0;
    }
  }
  .media-pic-topology{
    display: none;
    @media screen and (max-width: 768px) {
      display: block;
      /*margin-top: 5rem;*/
      width: 325px;
      height: auto;
      margin: 0 auto;
      margin-bottom: 20px;
    }
  }
}
.nkn-container:nth-child(odd) {
  background-color: #f9faff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/PartnerPortal.vue